import {
	capitalize,
} from '@modules/text';

export interface AddressJson {
	building_name?: string;
	city?: string;
	full?: string;
	postal_code?: string;
	street?: string;
	street_numbers?: Array<string>;
	street_raw?: string;
	street_type?: string;
}

export class Address {
	public address: AddressJson;

	constructor(
		address: AddressJson,
	) {
		this.address = address;
	}

	get building_name(): string | undefined {
		return this.address?.building_name ? capitalize(this.address.building_name) : undefined;
	}

	get building_name_street_numbers(): string | undefined {
		let result: string | undefined = undefined;
		const resultArray: string[] = [];
		if (this.building_name) resultArray.push(this.building_name);
		if (this.street_numbers_street_type_street) resultArray.push(this.street_numbers_street_type_street);

		result = resultArray.length ? resultArray.join(' - ') : undefined;
		return result;
	}

	get city(): string | undefined {
		return this.address?.city ? capitalize(this.address.city) : undefined;
	}

	get full(): string | undefined {
		let fullAddress: string | undefined = undefined;
		if (this.street_raw?.length) {
			fullAddress = this.building_name ? `${this.building_name} - ${this.street_raw}` : this.street_raw;
		} else if ((this.building_name_street_numbers && this.building_name_street_numbers.length) || (this.postal_code_city && this.postal_code_city.length)) {
			const results: Array<string> = [];

			if (this.building_name_street_numbers && this.building_name_street_numbers.length) results.push(this.building_name_street_numbers);
			if (this.postal_code_city && this.postal_code_city.length) results.push(this.postal_code_city);

			fullAddress = results.join(', ');
		}

		return fullAddress;
	}

	get postal_code(): string | undefined {
		return this.address?.postal_code;
	}

	get postal_code_city(): string | undefined {
		let result: string | undefined = undefined;
		const postalCodeAndCity = `${this.postal_code}\u00A0${this.city}`;
		if (this.postal_code && this.city) {
			result = postalCodeAndCity;
		} else if (this.postal_code && !this.city) {
			result = this.postal_code;
		} else if (this.city) {
			result = capitalize(this.city);
		}
		return result;
	}

	get street(): string | undefined {
		return this.address?.street;
	}

	get street_numbers_city_postal_code(): string | undefined {
		let result: string | undefined = undefined;
		const resultArray: string[] = [];
		if (this.street_raw?.length) {
			resultArray.push(this.street_raw);
		} else {
			if (this.street_numbers_street_type_street?.length) resultArray.push(this.street_numbers_street_type_street);
			if (this.postal_code_city?.length) resultArray.push(this.postal_code_city);
		}
		result = resultArray.filter(result => result.length).join(', ');
		return result;
	}

	/**
	 * @returns the numbers and the street type
	 */
	get street_numbers_street_type_street(): string | undefined {
		let result = undefined;
		const resultArray: string[] = [];
		if (this.street?.length && this.street_type?.length) {
			if (this.street_numbers_value?.length) {
				resultArray.push(this.street_numbers_value);
			}
			resultArray.push(this.street_type);
			resultArray.push(this.street);
		} else if (this.street?.length	) {
			resultArray.push(this.street);
		}
		result = resultArray.length ? resultArray.join(' ') : undefined;
		return result;
	}

	get street_numbers_value(): string | undefined {
		let numbersString : string | undefined = undefined;
		if (this.address?.street_numbers?.length) {
			const numbers = [
				...new Set(this.address.street_numbers), // to be sure to create array with unique values
			];
			if (numbers.length > 1) {
				numbersString = `${numbers[0]}-${numbers[numbers.length - 1]}`;
			} else {
				numbersString = numbers[0];
			}
		}
		return numbersString;
	}

	get street_raw(): string | undefined {
		return this.address?.street_raw;
	}

	get street_type(): string | undefined {
		return this.address?.street_type;
	}

	get street_type_street(): string | undefined {
		return this.street_type ? `${this.street_type} ${this.street}` : this.street;
	}
}
